<template>

<div>
  <LDBsTable
    url="stock-alerts"
    defaultSort="createdAt"
    defaultOrder="desc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label for="active_type">{{ $t('active_type') }}</label>
      <Combobox
        class="bg-white"
        name='active_type'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="activestypes"
        v-model="query.activeType"
        :reduce="activeType => activeType.id"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="manufacturer">{{ $t('manufacturer') }}</label>
      <Combobox
        multiple
        class="bg-white"
        name='manufacturer'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="manufacturers"
        v-model="query.manufacturer"
        :reduce="manufacturer => manufacturer.id"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="model">{{ $t('model') }}</label>
      <Combobox
        multiple
        class="bg-white"
        name='model'
        :placeholder="$t('select_a_item')"
        label="name"
        :getOptionLabel="model => model.name ? model.manufacturer.name + ' / ' + model.name : ''"
        :options="models"
        v-model="query.model"
        :reduce="model => model.id"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="location">{{ $t('location') }}</label>
      <Combobox
        class="bg-white"
        name='location'
        :placeholder="$t('select_a_item')"
        :options="locations"
        v-model="query.location"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="status">{{ $t('status') }}</label>
      <Combobox
        multiple
        class="bg-white"
        name='status'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="status.rows"
        v-model="query.status"
        :reduce="status => status.id"
      />
    </div>
  </LDBsTable>

  <!-- MODAL LOADING -->
  <div
    ref='modalLoading'
    id="modalLoading"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLoading"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Carregando...</h5>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-center mb-3">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import location from '@/config/locations'
import moment from 'moment'
import { request } from '@/lib/http'

export default {
  name: 'StockAlertsList',
  components: {
    LDBsTable,
    Combobox
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('active_type'),
          field: 'activeType',
          formatter: value => {
            return value
              ? value.name
              : '-'
          },
          // sortable: true
        },
        {
          title: this.$t('manufacturer'),
          field: 'manufacturer',
          formatter: value => {
            if (!value.length) {
              return ' - '
            }

            return value.map(item => item.name).join(', ')
          }
        },
        {
          title: this.$t('model'),
          field: 'model',
          formatter: value => {
            if (!value.length) {
              return ' - '
            }

            return value.map(item => item.name).join(', ')
          }
        },
        {
          title: this.$t('location'),
          field: 'location'
        },
        {
          title: this.$t('status'),
          field: 'status',
          formatter: function (value) {
            if (!value.length) {
              return ' - '
            }

            return value.map(item => item.name).join(', ')
          }
        },
        {
          title: this.$t('minimum'),
          field: 'minimum'
        },
        {
          title: this.$t('email'),
          field: 'email'
        },
        {
          title: this.$t('title'),
          field: 'title',
          visible: false
        },
        {
          title: this.$t('alert_message'),
          field: 'message',
          visible: false
        },
        {
          title: this.$t('frequency'),
          field: 'frequency',
          formatter: value => {
            let frequency = ''

            for (const item of value) {
              frequency += item.dayWeekName + ','
            }

            return frequency
          },
          visible: false
        },
        {
          title: this.$t('suspended'),
          field: 'suspendedUntil',
          formatter: value => {
            return value
              ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : '-'
          }
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: value => value ? 'SIM' : 'NÃO'
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            let buttons = `
              <a
                href="#/main/stock-alert/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen"/>
              </a>
            `
            if (row.suspendedUntil) {
              buttons += `
                <button
                  title="Remover suspensão de envio de e-mail"
                  data-target="#modalLoading"
                  data-toggle="modal"
                  data-id='${row.id}'
                  class="edit mb-1 btn btn-action btn-warning btn-circle light-bottom-shadow text-white"
                >
                  <i class="fas fa-ban fa-lg" />
                </button>
              `
            }

            return buttons
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'stock-alerts' }
      },
      query: {
        id          : undefined,
        status      : undefined,
        location    : '',
        activeType  : undefined,
        model       : undefined,
        manufacturer: undefined
      },
      locations: location
    }
  },

  computed: {
    ...mapState({
      manufacturers: state => state.manufacturer.all,
      activestypes : state => state.activestype.all,
      status       : state => state.status.all,
      models       : state => state.model.all,
    })
  },

  methods: {
    clear() {
      this.query.status       = undefined
      this.query.location     = ''
      this.query.activeType   = undefined
      this.query.model        = undefined
      this.query.manufacturer = undefined
    },

    async removeSuspensionSendEmail(id) {
      const result = await request({
        url   : `suspend-send-email/${id}`,
        method: 'patch'
      })

      if (result) {
        $('#search').trigger('click')
      }

      setTimeout(() => $('#modalLoading').modal('hide'), 500)
    }
  },

  async mounted() {
    const { dispatch } = this.$store
    dispatch('overlay/show', true)

    await dispatch('activestype/fetchAll')
    await dispatch('manufacturer/fetchAll')
    await dispatch('status/fetchAll')
    await dispatch('model/fetchAll')
    
    dispatch('overlay/show', false)

    const global = this
    // EXECUTA QUANDO MODAL UPLOAD É ACIONADO
    $('#modalLoading').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      global.removeSuspensionSendEmail(button.data('id'))
    })

    // EXECUTA QUANDO MODAL EDITAR É FECHADO
    // $('#modalLoading').on('hide.bs.modal', function (event) {
    //   global.file = null
    //   global.sendEmail = true
    //   global.alert.show = false
    //   if (global.reloadExtracts) $('#search').trigger('click')
    //   global.reloadExtracts = false
    //   global.extractId = undefined
    // })
  },

  destroyed() {
    const { dispatch } = this.$store

    dispatch('activestype/cleanState')
    dispatch('activestatus/cleanState')
    dispatch('manufacturer/cleanState')
    dispatch('status/cleanState')
    dispatch('model/cleanState')
    dispatch('stockalerts/cleanState')
  }
}
</script>